var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{staticClass:"pt-0 pb-4"},[_c('v-row',[_c('v-col',[_c('p',{staticClass:"all-caps-header mb-0"},[_vm._v(_vm._s(_vm.sectionName))])])],1),_vm._v(" "),_c('v-row',[_c('v-col',[_vm._t("default")],2)],1),_vm._v(" "),(_vm.hideDivider === false)?_c('v-divider',{staticClass:"mt-7"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }